import React from 'react';
import { motion } from 'framer-motion';
export function TreeRingsHero() {
  // Generate concentric tree rings with organic variation
  const rings = Array.from({
    length: 25
  }, (_, i) => {
    const baseRadius = 5 + i * 3.5;
    const variation = Math.sin(i * 0.5) * 0.5; // Organic irregularity
    return {
      id: i,
      radius: baseRadius + variation,
      strokeWidth: 0.15 + Math.random() * 0.15,
      opacity: 0.3 + Math.random() * 0.4,
      // Some rings are darker (representing harder growth years)
      isDark: Math.random() > 0.7
    };
  });
  // Wood grain texture lines
  const grainLines = Array.from({
    length: 30
  }, (_, i) => {
    const angle = i / 30 * Math.PI * 2;
    const startRadius = 5;
    const endRadius = 90;
    return {
      id: i,
      x1: 50 + Math.cos(angle) * startRadius,
      y1: 50 + Math.sin(angle) * startRadius,
      x2: 50 + Math.cos(angle) * endRadius,
      y2: 50 + Math.sin(angle) * endRadius
    };
  });
  return <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" data-id="element-218">
      <defs data-id="element-219">
        <radialGradient id="woodGradient" cx="50%" cy="50%" data-id="element-220">
          <stop offset="0%" stopColor="#1c3f4d" data-id="element-221" />
          <stop offset="50%" stopColor="#0e2533" data-id="element-222" />
          <stop offset="100%" stopColor="#000000" data-id="element-223" />
        </radialGradient>
        <radialGradient id="ringGradient" cx="50%" cy="50%" data-id="element-224">
          <stop offset="0%" stopColor="#78e1c4" stopOpacity="0.6" data-id="element-225" />
          <stop offset="100%" stopColor="#2BC7B7" stopOpacity="0.3" data-id="element-226" />
        </radialGradient>
        <filter id="ringGlow" data-id="element-227">
          <feGaussianBlur stdDeviation="0.2" result="coloredBlur" data-id="element-228" />
          <feMerge data-id="element-229">
            <feMergeNode in="coloredBlur" data-id="element-230" />
            <feMergeNode in="SourceGraphic" data-id="element-231" />
          </feMerge>
        </filter>
        {/* Organic noise texture */}
        <filter id="noise" data-id="element-232">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="4" result="noise" data-id="element-233" />
          <feColorMatrix in="noise" type="saturate" values="0" result="monoNoise" data-id="element-234" />
          <feBlend in="SourceGraphic" in2="monoNoise" mode="multiply" data-id="element-235" />
        </filter>
      </defs>

      {/* Background wood texture */}
      <rect width="100" height="100" fill="url(#woodGradient)" data-id="element-236" />

      {/* Subtle wood grain lines */}
      {grainLines.map((line, i) => <motion.line key={`grain-${line.id}`} x1={line.x1} y1={line.y1} x2={line.x2} y2={line.y2} stroke="#78e1c4" strokeWidth="0.03" opacity="0.03" initial={{
      pathLength: 0
    }} animate={{
      pathLength: 1
    }} transition={{
      duration: 3,
      delay: i * 0.03,
      ease: 'easeOut'
    }} data-id="element-237" />)}

      {/* Tree rings - growing from center */}
      {rings.map((ring, i) => <motion.circle key={ring.id} cx="50" cy="50" r={ring.radius} fill="none" stroke={ring.isDark ? '#2BC7B7' : '#78e1c4'} strokeWidth={ring.strokeWidth * 0.8} opacity={ring.opacity * 0.5} filter="url(#ringGlow)" initial={{
      r: 0,
      opacity: 0
    }} animate={{
      r: ring.radius,
      opacity: ring.opacity * 0.5
    }} transition={{
      duration: 1.2,
      delay: i * 0.1,
      ease: 'easeOut'
    }} data-id="element-238" />)}

      {/* Organic imperfections and knots */}
      {Array.from({
      length: 5
    }, (_, i) => {
      const angle = i / 5 * Math.PI * 2 + Math.random();
      const distance = 20 + Math.random() * 30;
      return <motion.circle key={`knot-${i}`} cx={50 + Math.cos(angle) * distance} cy={50 + Math.sin(angle) * distance} r={1 + Math.random() * 1.5} fill="#2BC7B7" opacity="0.15" initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 2.5 + i * 0.3
      }} data-id="element-239" />;
    })}

      {/* Growth pulse animation from center */}
      <motion.circle cx="50" cy="50" r="5" fill="none" stroke="#4DE7D4" strokeWidth="0.2" opacity="0.3" animate={{
      r: [5, 90],
      opacity: [0.3, 0]
    }} transition={{
      duration: 12,
      delay: 3,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-240" />

      {/* Center heartwood */}
      <motion.circle cx="50" cy="50" r="4" fill="url(#ringGradient)" filter="url(#ringGlow)" initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} data-id="element-241">
        <animate attributeName="opacity" values="0.4;0.5;0.4" dur="4s" repeatCount="indefinite" data-id="element-242" />
      </motion.circle>

      {/* Subtle texture overlay */}
      <rect width="100" height="100" fill="none" filter="url(#noise)" opacity="0.02" data-id="element-243" />
    </svg>;
}